export default __webpack_public_path__ + "static/media/checked.f349a0ed.svg";